import React from "react"
import addToMailchimp from "gatsby-plugin-mailchimp"

export default class NewsletterStrip extends React.Component {
  constructor(props) {
    super(props)
  }

  state = {
    email: "",
    responseMessage: "",
  }

  handleInputChange = event => {
    const target = event.target
    const value = target.value
    const name = target.name
    console.log(target)
    this.setState({
      [name]: value,
    })
  }

  handleSubmit = async e => {
    e.preventDefault()
    const result = await addToMailchimp(this.state.email)
    console.log(result)
    this.setState({ message: result.msg })
  }

  render() {
    const color = this.props.color || "green-600"
    console.log(this.props)
    return (
      <div className="mt-20 bg-gray-800">
        <div className="grid max-w-screen-xl grid-cols-2 px-4 py-12 mx-auto sm:px-6 lg:py-16 lg:px-8 lg:flex lg:items-center">
          <div className="justify-center col-span-7 lg:w-0 lg:flex-1">
            <h2 className="text-3xl font-bold leading-9 tracking-tight text-white sm:text-4xl sm:leading-10">
              Enjoy Problem Solving
            </h2>
            <p className="max-w-3xl mt-3 text-lg leading-6 text-gray-300">
              Subscribe to get free weekly content on DSA, Machine Learning and
              System Design. Content will be delivered every Monday.
            </p>
          </div>
          <div className="col-span-5 mt-8 lg:mt-0 lg:ml-8">
            <div
              className="max-w-xs my-2 prose-lg text-white text-wrap"
              dangerouslySetInnerHTML={{ __html: this.state.message }}
            />
            <form
              className="sm:flex"
              name="subscribeForm"
              onSubmit={this.handleSubmit}
              id="subscribe-form"
              method="POST"
            >
              <input
                type="email"
                name="email"
                value={this.state.email}
                onChange={this.handleInputChange}
                className="w-full px-5 py-3 text-base leading-6 text-gray-900 placeholder-gray-500 transition duration-150 ease-in-out bg-white border border-transparent rounded-md appearance-none focus:outline-none focus:placeholder-gray-400 sm:max-w-xs"
                placeholder="Enter your email"
              />
              <div className="flex justify-center mt-3 rounded-full lg:-ml-2 sm:mt-0 sm:ml-3 sm:flex-shrink-0">
                <button
                  type="submit"
                  className={
                    "flex items-center justify-center px-5 py-3 text-base font-medium leading-6 text-white transition duration-150 ease-in-out border border-transparent rounded-md bg-" +
                    color +
                    " hover:bg-" +
                    color +
                    " focus:outline-none"
                  }
                >
                  Subscribe
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}
